var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompassRoseCorner = function SvgCompassRoseCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-label": "Passport",
    className: "compass-rose-corner_svg__compass-rose-corner",
    viewBox: "0 0 142 142"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5680ff",
    d: "M0 0v141.23L141.23 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.088 40.025c0-16.508 13.5-29.937 30.095-29.937 16.593 0 30.094 13.43 30.094 29.937S56.777 69.96 40.183 69.96s-30.095-13.43-30.095-29.936m24.233-5.831 5.745-19.45c-13.923.063-25.235 11.316-25.298 25.165zm-19.553 5.945 19.553 5.716 5.745 19.449c-13.923-.062-25.235-11.316-25.298-25.165m25.53 25.165 5.745-19.45 19.551-5.715c-.062 13.849-11.374 25.103-25.297 25.165m25.297-25.395c-.062-13.85-11.374-25.103-25.297-25.165l5.745 19.45z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m32.521 28.731-.838 2.839-2.853.834-4.437-8.086zM55.97 24.32l-4.436 8.086-2.854-.834-.838-2.84zm-8.127 27 .839-2.84 2.854-.833 4.435 8.085zM28.83 47.645l-4.436 8.085 8.128-4.413-.838-2.838z",
    clipRule: "evenodd"
  })));
};
export default SvgCompassRoseCorner;